import React from 'react'
import images from '../../../../app/utlis/image'
import WEB1 from '../../../../app/assets/images/projectImage/eccprojectImage/web-1.png'
import WEB2 from '../../../../app/assets/images/projectImage/eccprojectImage/web-2.png'
import WEB3 from '../../../../app/assets/images/projectImage/eccprojectImage/web-3.png'
import WEB4 from '../../../../app/assets/images/projectImage/eccprojectImage/web-4.png'
import WEB5 from '../../../../app/assets/images/projectImage/eccprojectImage/web-5.png'
import WEB6 from '../../../../app/assets/images/projectImage/eccprojectImage/web-6.png'
import { motion } from 'framer-motion'

const EccProjectOverview = () => {
    // Animation variants
    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { 
            opacity: 1,
            transition: { 
                duration: 0.7, 
                ease: "easeOut"
            }
        }
    };

    const fadeInUp = {
        hidden: { opacity: 0, y: 50 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { 
                duration: 0.7, 
                ease: "easeOut" 
            }
        }
    };

    const imageAnimation = {
        hidden: { opacity: 0, scale: 0.95 },
        visible: { 
            opacity: 1, 
            scale: 1,
            transition: { 
                duration: 0.7, 
                ease: "easeOut" 
            }
        }
    };

    return (
        <div>
            <motion.div 
                className='flex flex-col md:flex-row px-4 md:px-32 gap-8 md:gap-32'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <motion.div variants={fadeInUp}>
                    <div className='text-2xl md:text-3xl font-bold'>Overview</div>
                    <div className='text-[#e0e0e0] pt-2 text-base md:text-lg'>Excellence care clinics operates as an independent center for
                        pain treatment, aiding patients with complicated cases
                        that do not respond to usual treatments. The care is delivered
                        by pain specialists and nurses. They are based in
                        Velsen-Noord, the Netherlands.</div>
                </motion.div>
                <motion.div 
                    className='bg-eccColor p-8 md:p-14 hidden rounded-full md:flex items-center justify-center md:ml-28'
                    variants={imageAnimation}
                >
                    <img src={images.ECCLOGO} className='w-32 md:w-auto' />
                </motion.div>
            </motion.div>

            <motion.div 
                className='bg-eccColor px-4 md:px-32 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 md:pr-48 mt-12 relative'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <motion.img 
                    src={images.ECCOBJECTIVEIMAGE} 
                    className='mt-8 relative -bottom-8 w-full md:w-auto' 
                    variants={imageAnimation}
                />
                <motion.div className='text-center md:text-left' variants={fadeInUp}>
                    <div className='text-2xl md:text-3xl font-bold'>Objectives</div>
                    <div className='text-[#e0e0e0] pt-2 text-base md:text-lg'>Click-to-Select Pain Areas: Offer an easy tool where users can click on various body parts of a picture to find
                        related pain treatments without needing to know
                        medical jargon.</div>
                </motion.div>
            </motion.div>

            {/* Solution section */}
            <motion.div 
                className='flex flex-col md:flex-row items-center justify-between px-4 md:px-32 py-8 md:py-12 gap-8 md:gap-32'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <motion.div className='w-full md:w-[40%] text-center md:text-left' variants={fadeInUp}>
                    <div className='text-2xl md:text-3xl font-bold'>Solutions</div>
                    <div className='text-[#e0e0e0] pt-2 text-base md:text-lg'>SATTVA TECH joined forces
                        to develop the Excellent Care Clinics website. We
                        used tools like WordPress and Elementor, along with
                        different plugins, to make the site perfect for
                        Excellent Care Clinics. We incorporated a 3D model
                        to enhance interactivity. Our coding skills enabled us
                        to adapt the site to the specific requirements of
                        Excellent Care Clinics, ensuring a personalized and impactful online presence.</div>
                </motion.div>
                <motion.div 
                    className='grid grid-cols-1 sm:grid-cols-2 gap-4 w-full md:w-auto'
                    variants={fadeIn}
                >
                    <motion.div 
                        className=''
                        whileHover={{ scale: 1.03 }}
                        transition={{ duration: 0.3 }}
                    >
                        <img src={WEB1} className='w-full h-auto' />
                    </motion.div>
                    <motion.div 
                        className=''
                        whileHover={{ scale: 1.03 }}
                        transition={{ duration: 0.3 }}
                    >
                        <img src={WEB2} className='w-full h-auto' />
                    </motion.div>
                    <motion.div 
                        className=''
                        whileHover={{ scale: 1.03 }}
                        transition={{ duration: 0.3 }}
                    >
                        <img src={WEB3} className='w-full h-auto' />
                    </motion.div>
                    <motion.div 
                        className=''
                        whileHover={{ scale: 1.03 }}
                        transition={{ duration: 0.3 }}
                    >
                        <img src={WEB4} className='w-full h-auto' />
                    </motion.div>
                </motion.div>
            </motion.div>

            <motion.div 
                className='bg-eccColor px-4 md:px-32 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 md:pr-48 mt-12 relative'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <motion.img 
                    src={WEB5} 
                    className='relative -bottom-8 w-full md:w-auto' 
                    variants={imageAnimation}
                />
                <motion.div className='text-center md:text-left' variants={fadeInUp}>
                    <div className='text-2xl md:text-3xl font-bold'>The dream</div>
                    <div className='text-[#e0e0e0] pt-2 text-base md:text-lg'>Excellence care clinics approached Sattva Tech to build a
                        premium website that features their best doctors and a
                        range of treatments. They wanted a site that is easy to use
                        and provides informative content about their healthcare
                        services.</div>
                </motion.div>
            </motion.div>

            {/* Details section */}
            <motion.div 
                className='flex flex-col md:flex-row items-center justify-between px-4 md:px-32 py-8 md:py-12 gap-8 md:gap-32'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <motion.div className='w-full md:w-[40%] text-center md:text-left' variants={fadeInUp}>
                    <div className='text-2xl md:text-3xl font-bold'>Excellence care clinics details</div>
                    <div className='text-[#e0e0e0] pt-2 text-base md:text-lg'>The website is now easier to use because we divided it into
                        sections for different pain types. Visitors can easily look through
                        each category to find the right treatments. Finding information
                        about specific pain conditions and treatments is simpler, making
                        the site more user-friendly. We aim to help people make smart
                        choices for pain management, so we provide clear information
                        about available treatments in each section, assisting visitors
                        in making the best decisions for themselves.</div>
                </motion.div>
                <motion.div variants={imageAnimation} className='w-full md:w-auto'>
                    <img src={WEB6} className='w-full h-auto' />
                </motion.div>
            </motion.div>
        </div>
    )
}

export default EccProjectOverview
